<template>
  <layout-div>
    <div class="row justify-content-md-center full-screen-bg">
      <div class="col-12">
        <nav class="navbar navbar-expand-lg">
          <div class="container-fluid mt-1">
            <div class="navbar-brand-box text-center" @click="$router.push('/')">
              <img src="@/assets/Logo_pro.png" alt="Logo" style="width: 120px; height: auto;" />
            </div>
            <div class="text-end">
              <div class="time-tracking-container">
                <div class="dropdown-container">
                  <div class="dropdown">
                    <a class="nav-link dropdown-toggle text-capitalize" id="dropdownMenuButton" role="button"
                      data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false"
                      style="color: white; font-size: 15px;">
                      {{ fullname }}
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end text-center" aria-labelledby="dropdownMenuButton">
                      <li><a class="dropdown-item" href="#" @click="$router.push('/profile')">Profil</a></li>
                      <hr>
                      <li><a class="dropdown-item" href="#" @click="logout">Abmelden</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <hr class="mt-0" />
        <div class="row mt-2 mb-1">
          <div class="col-12 col-md-8">
            <div class="card entry-card customcard">
              <div class="card-body">
                <template v-if="loading">
                  <div class="text-center">
                    <div class="spinner-border text-dark" role="status"></div>
                  </div>
                </template>
                <template v-else>
                  <form @submit.prevent="handleSubmit">
                    <div class="section-header d-flex justify-content-between align-items-center">
                      <h5 class="section-title mt-3">Persönliche Daten</h5>
                      <button type="button" class="btn btn-link" @click="$router.push('/')">
                        <i class="bi bi-arrow-left mt-1" style="font-weight: bold;"></i>
                      </button>
                    </div>
                    <div class="form-section">
                      <div class="row mb-3">
                        <label for="first_name" class="col-4 col-form-label">Vorname</label>
                        <div class="col-8">
                          <input type="text" id="first_name" class="form-control" v-model="form.first_name"
                            placeholder="Vorname" />
                          <small v-if="validationErrors.first_name" class="text-danger mt-1">{{ validationErrors.first_name
                            }}</small>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label for="surname" class="col-4 col-form-label">Nachname</label>
                        <div class="col-8">
                          <input type="text" id="surname" class="form-control" v-model="form.surname"
                            placeholder="Nachname" />
                          <small v-if="validationErrors.surname" class="text-danger mt-1">{{ validationErrors.surname
                            }}</small>
                        </div>
                      </div>
                      <div class="row mb-3 align-items-center">
                        <label for="street" class="col-4 col-form-label">Straße/Nr</label>
                        <div class="col-5 pe-1">
                          <input type="text" id="street" class="form-control" v-model="form.street"
                            placeholder="Straße" />
                        </div>
                        <div class="col-3 ps-1">
                          <input type="text" id="house_num" class="form-control" v-model="form.house_num"
                            placeholder="Nr" />
                        </div>
                      </div>
                      <div class="row mb-3 align-items-center">
                        <label for="postal_code" class="col-4 col-form-label">PLZ</label>
                        <div class="col-8">
                          <input type="text" id="postal_code" class="form-control" v-model="form.postal_code"
                            placeholder="PLZ" />
                          <small v-if="validationErrors.postal_code" class="text-danger mt-1">{{
                            validationErrors.postal_code
                            }}</small>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label for="location" class="col-4 col-form-label">Stadt</label>
                        <div class="col-8">
                          <input type="text" id="location" class="form-control" v-model="form.location"
                            placeholder="Stadt" />
                        </div>
                      </div>
                    </div>
                    <h5 class="section-title text-start">Kontaktdaten</h5>
                    <div class="form-section">
                      <div class="row mb-3">
                        <label for="landline" class="col-4 col-form-label">Festnetz</label>
                        <div class="col-8">
                          <input type="text" id="landline" class="form-control" v-model="form.landline"
                            placeholder="Festnetz" />
                          <small v-if="validationErrors.landline" class="text-danger mt-1">
                            {{ validationErrors.landline }}
                          </small>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label for="mobile" class="col-4 col-form-label">Mobile</label>
                        <div class="col-8">
                          <input type="text" id="mobile" class="form-control" v-model="form.mobile"
                            placeholder="Mobile" />
                          <small v-if="validationErrors.mobile" class="text-danger mt-1">
                            {{ validationErrors.mobile }}
                          </small>
                        </div>
                      </div>

                    </div>
                    <h5 class="section-title text-start">Bankverbindung</h5>
                    <div class="form-section">
                      <div class="row mb-3">
                        <label for="iban" class="col-4 col-form-label">IBAN</label>
                        <div class="col-8">
                          <input type="text" id="iban" class="form-control" v-model="form.iban" placeholder="IBAN"
                            @input="fetchBIC" />
                        </div>
                      </div>
                      <div class="row mb-3">
                        <label for="bic" class="col-4 col-form-label">BIC</label>
                        <div class="col-8">
                          <input type="text" id="bic" class="form-control" v-model="form.bic" placeholder="BIC" disabled
                            readonly />
                        </div>
                      </div>

                    </div>
                    <div v-if="status == 'SEND'" class="mb-3" style="color: rgb(0 0 0) !important;background: rgb(255, 236, 179);padding: 5px;border-radius: 5px;">
                      <small>
                        Ihre vorherige Zustimmung zu den Änderungen steht noch aus. Versuchen Sie es erneut, nachdem die Genehmigung angenommen oder abgelehnt wurde.
                      </small>
                    </div>
                    <div v-if="Object.keys(validationErrors).length !== 0" class="text-end mb-1">
                      <small class="text-end text-danger">
                        Bitte überprüfen Sie die Fehler!
                      </small>
                    </div>
                    <div class="text-end">
                      <button class="btn btn-secondary me-2" @click="$router.push('/')" :disabled="buttonLoading">Zurück</button>
                      <button class="btn btn-success" type="button" disabled v-if="buttonLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Laden...
                      </button>
                      <button v-else type="submit" class="btn btn-success" :disabled="status=='SEND'">Speichern</button>
                    </div>
                  </form>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-div>
</template>


<script>
import tokenService from '@/tokenService';
import LayoutDiv from './LayoutDiv.vue';
import $ from 'jquery';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { API_BASE_URL, API_WIDGET } from '../config';
import { onMounted, ref } from "vue";
import { Dropdown } from "bootstrap";

export default {
  name: 'Profile',
  components: {
    LayoutDiv,
  },
  setup() {
    onMounted(() => {
      const dropdownElement = document.querySelector(".dropdown-toggle");
      if (dropdownElement) {
        new Dropdown(dropdownElement);
      }
    });
  },
  data() {
    return {
      name: '',
      loading: true,
      buttonLoading: false,
      screenHeight: null,
      fullname: '',
      validationErrors: {},
      form: {
        first_name: '',
        surname: '',
        street: '',
        house_num: '',
        postal_code: '',
        location: '',
        landline: '',
        mobile: '',
        iban: '',
        bic: '',
      },
      status: null
    };
  },
  async created() {
    this.fullname = localStorage.getItem('fullname');
    await this.getProfile();
  },
  methods: {
    async getProfile() {
      const storedUsername = tokenService.getStoredUsername();
      const context = this
      this.loading = true
      await $.ajax({
        type: "POST",
        url: `${API_BASE_URL}/${API_WIDGET}/UserTimeRecord/timeRecord.php`,
        data: { action: "getCurrentUserData", username: storedUsername },
        success: function (response) {
          response = JSON.parse(response);
          context.form = response.data[0]
          context.status = response.status
          context.loading = false
        }
      });

    },
    async handleSubmit() {
      await this.validateForm();
      if (Object.keys(this.validationErrors).length === 0) {
        this.buttonLoading = true
        const context = this
        await $.ajax({
          type: "POST",
          url: `${API_BASE_URL}/${API_WIDGET}/UserTimeRecord/timeRecord.php`,
          data: { action: "updateCurrentUserData", data: context.form },
          success: function (response) {
            const $toast = useToast();
            const res = typeof response === "string" ? JSON.parse(response) : response;
            context.buttonLoading = false
            if (res.status) {
              context.status = res.status;
            }
            $toast.open({
              message: 'Ihre Datenänderung wurde zur Genehmigung eingereicht.',
              type: 'success',
              position: 'top-right'
            });
          },
          error: function (xhr, error) {
            const $toast = useToast();
            context.buttonLoading = false;
            $toast.open({
              message: `Fehler beim Speichern der Daten: ${xhr?.responseText || error}`,
              type: 'error',
              position: 'top-right'
            });
          }
        });
      }
    },
    async fetchBIC() {
      this.form.bic = '';
      if (this.form.iban && this.form.iban.length >= 15) {
        try {
          const context = this
          await $.ajax({
            url: `https://openiban.com/validate/${context.form.iban}?getBIC=true&validateBankCode=true`,
            success: function (data) {
              var result = data;
              if (result.valid) {
                context.form.bic = result?.bankData.bic
              }
            },
            error: function (xhr) {
            }
          });
        } catch (error) {
          this.validationErrors.bic = "Fehler beim Abrufen der BIC.";
        }
      }
    },
    async validateForm() {
      this.validationErrors = {};

      if (!this.form.first_name) {
        this.validationErrors.first_name = 'Vorname ist erforderlich';
      }
      if (!this.form.surname) {
        this.validationErrors.surname = 'Nachname ist erforderlich';
      }
      const phoneRegex = /^[^a-zA-Z]*$/;
      if (this.form.mobile && !phoneRegex.test(this.form.mobile)) {
        this.validationErrors.mobile = 'Mobile darf keine Buchstaben enthalten';
      }
      if (this.form.landline && !phoneRegex.test(this.form.landline)) {
        this.validationErrors.landline = 'Festnetz darf keine Buchstaben enthalten';
      }
    },
    async logout() {
      tokenService.clearToken();
      this.$router.push('/login');

    },
  },
};
</script>
<style scoped>
.navbar-brand-box {
  display: inline-block;
  padding: 2px;
  border: 0 solid rgb(99, 149, 173);
  border-radius: 5px;
}

.customcard {
  background-color: #ffffff;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  left: 0;
  position: absolute;
  min-height: 100%;
  z-index: 12;
  width: 100%;
}

.navbar-brand {
  color: white;
  text-decoration: none;
}

.nav-link {
  color: white;
  text-decoration: none;
}

.dropdown-menu {
  background-color: #4c5382;
}

.dropdown-item {
  color: white;
}

.container {
  flex: 1;
  background-color: white;
}

hr {
  border-top: 2px solid lightblue;
}

.timer-info {
  font-size: 24px;
  color: white;
}

.noentry {
  margin-top: 20%;
}

.btn-outline-success {
  background-color: #28a745;
  color: white;
  font-weight: bold;
}

.btn-danger-background {
  background-color: #dc3545;
  color: white;
  font-weight: bold;
}

.btn-primary-background {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.custom-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  background-color: #28a745;
  color: #fff;
}

@media (max-width: 767px) {

  body,
  html {
    background-color: #121738;
  }
}

body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
}

.dropdown-menu.poper.text-center.show {
  position: absolute;
  left: 0%;
}

.full-screen-bg {
  background-color: #121738;
  height: 100vh;
}

.dropdown-menu :hover {
  background-color: transparent !important;
  color: white;
}

.form-group {
  margin-bottom: 1rem;
}

h5 {
  margin-bottom: 1rem;
}

button {
  padding: 0.75rem 1.5rem;
  font-size: 16px;
}

.form-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.section-title {
  margin-bottom: 15px;
}

.col-form-label {
  text-align: right;
}

button {
  padding: 0.75rem 1.5rem;
  font-size: 16px;
}

.btn-block {
  width: 100%;
}

@media (max-width: 768px) {
  .form-section {
    padding: 15px;
  }

  .col-form-label {
    text-align: left !important;
  }

  .dropdown-menu {
    position: relative;
  }
}

small.text-danger {
  font-size: 12px;
  display: block;
  margin-left: 0;
  text-align: left;
}
.dropdown-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  position: relative;
}

.dropdown-menu {
  position: absolute !important;
  min-width: 150px;
  max-width: 90vw;
  white-space: nowrap;
  z-index: 1050;
}

.dropdown-menu-end {
  right: 0 !important;
  left: auto !important;
}

@media (max-width: 768px) {
  .dropdown-menu {
    transform: translateX(-50%) !important;
    left: 50% !important;
    right: auto !important;
  }
}
</style>
